import ScheduleLayout from '@/layouts/ScheduleLayout.vue'

export const SCHEDULE_ROUTES = [
  {
    path: 'schedule',
    component: ScheduleLayout,
    redirect: { name: 'UpcomingJobs' },
    children: [
      {
        path: 'upcoming-jobs',
        name: 'UpcomingJobs',
        component: () => import('./views/UpcomingJobs.vue'),
      },
      {
        path: 'schedule-board',
        name: 'ScheduleBoard',
        component: () => import('./views/ScheduleBoard.vue'),
      },
    ],
  },
]

export const FIELD_SCHEDULE_ROUTES = [
  {
    path: 'schedule',
    name: 'FieldSchedule',
    component: () => import('./views/FieldSchedule.vue'),
  },
]
